import { ls } from './config.js';
/*
 * Parses the query string(URL)
 *
 * @Class Reporting Query String
 * @since 1.0.1
 *
 */
var reportingQueryString = {};

//Store array query string data values
reportingQueryString.vars = undefined;

reportingQueryString.isTinCanOnly = false;

reportingQueryString.init = function(){
	// Nothing to do here. Code moved to PHP.
};

export {
	reportingQueryString
}
